/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "com.atproto.sync.getBlocks";

export { $nsid };

export const $params = /*#__PURE__*/ l.params({"did":/*#__PURE__*/ l.string({"format":"did"}),"cids":/*#__PURE__*/ l.array(/*#__PURE__*/ l.string({"format":"cid"}), )});

export type $Params = l.InferOutput<typeof $params>;

export const $output = /*#__PURE__*/ l.payload("application/vnd.ipld.car");

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Get data blocks from a given repo, by CID. For example, intermediate MST nodes, or records. Does not require auth; implemented by PDS. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ["BlockNotFound","RepoNotFound","RepoTakendown","RepoSuspended","RepoDeactivated"]);

export { main };

export const $lxm = $nsid;
